import React from 'react';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { createRouter } from '@uhg-abyss/web/tools/createRouter';
import { AbyssProvider } from '@uhg-abyss/web/ui/AbyssProvider';
import { Routes } from './routes';
import { AuthProvider } from './auth';
import { ErrorProvider } from './common/ErrorHandler';

const theme = createTheme('uhc');
const router = createRouter(Routes);

export const browser = () => {
  return (
    <AuthProvider>
      <ErrorProvider>
        <AbyssProvider theme={theme} router={router} />
      </ErrorProvider>
    </AuthProvider>
  );
};
